import { AdminApp } from './components/AdminApp'
import { PublicApp } from './components/PublicApp'

export default function App() {
  return window.location.pathname.startsWith('/admin') ? <AdminApp /> : <PublicApp />
}
